import { eventTimeline } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';
import Reveal from '@/components/base/Reveal';

const dotStyles: Record<string, string> = {
  done: 'bg-secondary-500',
  current: 'bg-primary-500',
  upcoming: 'bg-background-400',
};

const labelStyles: Record<string, string> = {
  done: 'bg-secondary-100 text-secondary-900',
  current: 'bg-primary-100 text-primary-800',
  upcoming: 'bg-background-200 text-foreground-600',
};

const labelText: Record<string, string> = {
  done: '已发生',
  current: '正在进行',
  upcoming: '待更新',
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1360px] px-4 md:px-6">
        <SectionHeading
          kicker="事件进展"
          title="一条线，跟到今天为止"
          desc="把散落在不同帖子里的关键节点串起来，你就能看清一件事是怎么一步步走到现在的，以及下一步会等来什么。"
          actionLabel="订阅进展提醒"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-10">
          <ol className="relative border-l-2 border-background-200 pl-6">
            {eventTimeline.map((item, index) => (
              <Reveal key={item.time} delay={index * 70}>
                <li className="relative pb-8 last:pb-0">
                  <span
                    className={`absolute -left-[31px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-100 ${dotStyles[item.status]}`}
                  >
                    {item.status === 'current' && <span className="live-dot h-1.5 w-1.5 rounded-full bg-background-50" />}
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-heading text-sm font-bold text-primary-700">{item.time}</span>
                    <span className={`rounded px-2 py-0.5 text-[11px] font-medium ${labelStyles[item.status]}`}>
                      {labelText[item.status]}
                    </span>
                  </div>
                  <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                  <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </li>
              </Reveal>
            ))}
          </ol>

          <Reveal delay={120}>
            <div className="flex h-full flex-col gap-5">
              <div className="rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="text-xs tracking-[0.25em] text-foreground-400">NEXT</span>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">接下来最值得盯的是什么</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  暂定今晚的波形比对结果，是整条时间线里唯一还没有落地的环节。讨论区已经开了专题帖，
                  不管结论指向哪一边，都会第一时间更新到这条时间线上。
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-3">
                  <a
                    href="#live"
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    <i className="ri-notification-3-line" />
                    跟进这条进展
                  </a>
                  <a
                    href="#essence"
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                  >
                    看相关精华帖
                  </a>
                </div>
              </div>

              <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-6">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-secondary-950">
                  <i className="ri-time-line" />
                  这条时间线是怎么来的
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-secondary-900">
                  所有节点都由讨论区网友提供来源后逐条核对，标注不出处的线索不会进入时间线。
                  如果你手里有能补上的材料，欢迎在对应帖子里跟帖补充。
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}